import React from 'react';
import { MessageCircleIcon, ZapIcon, ShoppingBagIcon } from 'lucide-react';
const UseCases = () => {
  return <section className="py-16 bg-white" data-id="element-2301">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2302">
        <div className="text-center mb-12" data-id="element-2303">
          <h2 className="text-3xl font-bold mb-4" data-id="element-2304">Real-World Use Cases</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-2305">
            See how our AI shopping advisors help customers find exactly what
            they need across different retail categories
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-2306">
          {/* Electronics Use Case */}
          <div className="bg-white rounded-xl shadow-card overflow-hidden border border-gray-200" data-id="element-2307">
            <div className="p-4 bg-primary/5 border-b flex items-center" data-id="element-2308">
              <div className="w-10 h-10 rounded-full bg-white p-2 mr-3 flex items-center justify-center" data-id="element-2309">
                <MessageCircleIcon className="h-6 w-6 text-primary" data-id="element-2310" />
              </div>
              <div data-id="element-2311">
                <h3 className="font-semibold" data-id="element-2312">Electronics Shopping</h3>
                <p className="text-xs text-gray-500" data-id="element-2313">Tech & Gaming</p>
              </div>
            </div>
            <div className="p-4" data-id="element-2314">
              <div className="mb-4 rounded-lg overflow-hidden border border-gray-100" data-id="element-2315">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/xqCvzVYoEVd3gfMZHGz9D5/ChatGPT_Image_Sep_9%2C_2025%2C_10_52_02_PM.png" alt="AI helping customer find a gaming laptop" className="w-full h-auto" data-id="element-2316" />
              </div>
              <div className="space-y-3" data-id="element-2317">
                <h4 className="font-medium text-lg" data-id="element-2318">
                  Smart Product Recommendations
                </h4>
                <p className="text-gray-600 text-sm" data-id="element-2319">
                  Our AI understands specific tech needs and budget constraints,
                  guiding customers to the perfect products with personalized
                  recommendations and expert insights.
                </p>
                <div className="flex items-center justify-between text-sm mt-4" data-id="element-2320">
                  <div className="flex items-center text-primary" data-id="element-2321">
                    <ZapIcon className="h-4 w-4 mr-1" data-id="element-2322" />
                    <span data-id="element-2323">+53% conversion rate</span>
                  </div>
                  <div className="flex items-center text-gray-500" data-id="element-2324">
                    <ShoppingBagIcon className="h-4 w-4 mr-1" data-id="element-2325" />
                    <span data-id="element-2326">+41% AOV</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Home Goods Use Case */}
          <div className="bg-white rounded-xl shadow-card overflow-hidden border border-gray-200" data-id="element-2327">
            <div className="p-4 bg-primary/5 border-b flex items-center" data-id="element-2328">
              <div className="w-10 h-10 rounded-full bg-white p-2 mr-3 flex items-center justify-center" data-id="element-2329">
                <MessageCircleIcon className="h-6 w-6 text-primary" data-id="element-2330" />
              </div>
              <div data-id="element-2331">
                <h3 className="font-semibold" data-id="element-2332">Home Goods Shopping</h3>
                <p className="text-xs text-gray-500" data-id="element-2333">Bedding & Decor</p>
              </div>
            </div>
            <div className="p-4" data-id="element-2334">
              <div className="mb-4 rounded-lg overflow-hidden border border-gray-100" data-id="element-2335">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rixZfpRqKQQBinSAuYQj1E/ChatGPT_Image_Sep_9%2C_2025%2C_10_43_50_PM.png" alt="AI helping customer find a blue floral duvet" className="w-full h-auto" data-id="element-2336" />
              </div>
              <div className="space-y-3" data-id="element-2337">
                <h4 className="font-medium text-lg" data-id="element-2338">
                  Intuitive Search & Discovery
                </h4>
                <p className="text-gray-600 text-sm" data-id="element-2339">
                  Customers describe what they're looking for in natural
                  language, and our AI instantly shows matching products,
                  suggests complementary items, and helps complete the look.
                </p>
                <div className="flex items-center justify-between text-sm mt-4" data-id="element-2340">
                  <div className="flex items-center text-primary" data-id="element-2341">
                    <ZapIcon className="h-4 w-4 mr-1" data-id="element-2342" />
                    <span data-id="element-2343">+47% conversion rate</span>
                  </div>
                  <div className="flex items-center text-gray-500" data-id="element-2344">
                    <ShoppingBagIcon className="h-4 w-4 mr-1" data-id="element-2345" />
                    <span data-id="element-2346">+38% AOV</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Fashion Use Case */}
          <div className="bg-white rounded-xl shadow-card overflow-hidden border border-gray-200" data-id="element-2347">
            <div className="p-4 bg-primary/5 border-b flex items-center" data-id="element-2348">
              <div className="w-10 h-10 rounded-full bg-white p-2 mr-3 flex items-center justify-center" data-id="element-2349">
                <MessageCircleIcon className="h-6 w-6 text-primary" data-id="element-2350" />
              </div>
              <div data-id="element-2351">
                <h3 className="font-semibold" data-id="element-2352">Fashion Shopping</h3>
                <p className="text-xs text-gray-500" data-id="element-2353">Apparel & Clothing</p>
              </div>
            </div>
            <div className="p-4" data-id="element-2354">
              <div className="mb-4 rounded-lg overflow-hidden border border-gray-100" data-id="element-2355">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hbAQYYJxfnyCmb3EjHdDu1/ChatGPT_Image_Sep_9%2C_2025%2C_10_41_47_PM.png" alt="AI helping customer find a lightweight shirt" className="w-full h-auto" data-id="element-2356" />
              </div>
              <div className="space-y-3" data-id="element-2357">
                <h4 className="font-medium text-lg" data-id="element-2358">
                  Personal Styling Assistant
                </h4>
                <p className="text-gray-600 text-sm" data-id="element-2359">
                  Our AI acts as a personal stylist, understanding customer
                  preferences and helping them find the perfect clothing items
                  with helpful suggestions and style advice.
                </p>
                <div className="flex items-center justify-between text-sm mt-4" data-id="element-2360">
                  <div className="flex items-center text-primary" data-id="element-2361">
                    <ZapIcon className="h-4 w-4 mr-1" data-id="element-2362" />
                    <span data-id="element-2363">+49% conversion rate</span>
                  </div>
                  <div className="flex items-center text-gray-500" data-id="element-2364">
                    <ShoppingBagIcon className="h-4 w-4 mr-1" data-id="element-2365" />
                    <span data-id="element-2366">+32% AOV</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default UseCases;